import { render, staticRenderFns } from "./ReportDealerCallLogs.vue?vue&type=template&id=c60dc75e&"
import script from "./ReportDealerCallLogs.vue?vue&type=script&lang=js&"
export * from "./ReportDealerCallLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports